import { useAuthStore } from "@enos-monorepo/lib";
import { Navigate } from "react-router";

interface AuthGuardProps {
  children?: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/login" />;

  return children;
}
